export default __webpack_public_path__ + "static/media/upload.304f5095.svg";